import { Box, Typography } from '@mui/material';
import { rapcoinIconSrc, totalReferredIconSrc } from '../../assets/referrals';
import { getFormattedReferredCount } from '../../services/referralService';

const CARD_VARIANTS = {
  rapcoins: {
    label: 'Total RapCoins Earned',
    outerBorder: '#0048ff',
    outerGradient: 'linear-gradient(90deg, #0048ff 1%, #002b99 99.125%)',
    innerBorder: '#003acc',
    innerGradient: 'linear-gradient(255.54deg, #0048ff 0%, #002b99 99.876%)',
    icon: rapcoinIconSrc,
    iconSize: 28,
  },
  referred: {
    label: 'Total Referred',
    labelSx: {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.5px',
      fontWeight: 500,
    },
    outerBorder: '#2ee437',
    outerGradient: 'linear-gradient(90deg, #2ee437 1%, #1c8921 99.125%)',
    innerBorder: '#25b62c',
    innerGradient: 'linear-gradient(255.54deg, #2ee437 0%, #1c8921 99.876%)',
    icon: totalReferredIconSrc,
    iconSize: 32,
  },
};

/** Figma 11147:1539 / 1606 — referral summary stat cards */
export default function ReferralStatCard({ variant = 'rapcoins', value }) {
  const config = CARD_VARIANTS[variant] || CARD_VARIANTS.rapcoins;
  const displayValue =
    variant === 'referred' ? getFormattedReferredCount(value) : String(value ?? 0);

  return (
    <Box sx={{ width: '100%', maxWidth: 390, mx: 'auto' }}>
      <Box
        sx={{
          borderRadius: '22px',
          border: `0.5px solid ${config.outerBorder}`,
          background: config.outerGradient,
          p: '5px',
        }}
      >
        <Box
          sx={{
            border: '1px dashed #fff',
            borderRadius: '16px',
            p: '5px',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              borderRadius: '12px',
              border: `0.4px solid ${config.innerBorder}`,
              background: config.innerGradient,
              boxShadow: 'inset -2px -2px 15px rgba(98, 0, 82, 0.5)',
              minHeight: 74,
              px: 1.5,
              pt: 1.25,
              pb: 1.5,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: 12,
                lineHeight: '20px',
                letterSpacing: '0.8px',
                color: '#fff',
                opacity: 0.7,
                mb: 0.75,
                ...config.labelSx,
              }}
            >
              {config.label}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                component="img"
                src={config.icon}
                alt=""
                sx={{
                  width: config.iconSize,
                  height: config.iconSize,
                  objectFit: 'contain',
                  display: 'block',
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 700,
                  fontSize: 20,
                  lineHeight: '32px',
                  letterSpacing: '0.8px',
                  color: '#fff',
                }}
              >
                {displayValue}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
